export default __webpack_public_path__ + "static/media/jonathanHeadshot.53c29634.jpg";